<template>
  <footer class=" border-solid border-t-2 footer__container" v-if="isDataLoaded">
    <div class="footer__content-container default-container">
      <div class="footer__content-inner-container">
        <div class="footer-left__container">
          <div class="footer-left__inner-container">
            <template>
              <a :href="logoLink && logoLink.uri ? formattedMenuLink(logoLink):'#'" data-ga-group="menu_bar" data-ga-element="logo">
                <template v-if="blackSiteLogo && blackSiteLogo.imageMedia && blackSiteLogo.imageMedia.file.url">
                  <img class="headerLogo" :src="blackSiteLogo.imageMedia.file.url" alt="wk logo black" :style="headerLogoStyle"/>
                </template>
                <template v-else>
                  <div class="headerLogo" v-html="textLogo.processed"></div>
                </template>
              </a>
            </template>
            <div class="flex justify-center text-black">
              <template v-if="socialMediaIcons" v-for="(mediaIcon, index) in socialMediaIcons">
                <a :href="formattedMenuLink(mediaIcon.iconLink)" target="_blank" class="mx-2" data-ga-group="footer" data-ga-element="social_media" :data-ga-index="index+1" :link_text="mediaIcon.iconImage.altText">
                  <img :src="mediaIcon.iconImage.file.url" :alt="mediaIcon.iconImage.altText" class="footer-icon-image">
                  <span class="sr-only">{{ mediaIcon.iconImage.altText }}</span>
                </a>
              </template>
            </div>
          </div>
        </div>
        <div class="footer__center-column">
          <div class="footer-center-column__inner-container">
            <div class="footer__mail-section">
              <h6 class="self-start">{{ footerSecondaryMenuItem.newsLetterDescription ? footerSecondaryMenuItem.newsLetterDescription : $t("newsletter.button") }}</h6>
              <form method="GET" :action="newsletter">
                <div class="footer-input__container">
                  <input type="email" class="footer-input" placeholder="Enter email address" name="Email">
                  <button type="submit" data-ga-group="footer" data-ga-element="enews_signup_button">
                    <div class="rounded-item__container footer-input__button">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" class="fill-wk-gray-500 arrow-icon">submit<g id="Group_10482" data-name="Group 10482" transform="translate(-4987 -13508)"><rect id="Rectangle_648" data-name="Rectangle 648" width="24" height="24" transform="translate(4987 13508)" fill="none"></rect><path id="Path_450" data-name="Path 450" d="M3.822,0,7.171,5.8,3.438,11.608H0L4.166,5.719.612,0Z" transform="translate(4995.395 13514.195)"></path></g></svg>
                    </div>
                  </button>
                </div>
              </form>
            </div>
            <div class="footer-center-link__section default-container">
              <ul v-if="footerSecondaryMenuItem.footerColumn1" class="footer-center-link__container">
                <template v-for="(footerColumn1, index) in footerSecondaryMenuItem.footerColumn1">
                  <a v-if="footerColumn1.menuLink" :href="formattedMenuLink(footerColumn1.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn1.menuLabel }}</a>
                </template>
              </ul>
              <ul v-if="footerSecondaryMenuItem.footerColumn2" class="footer-center-link__container">
                <template v-for="(footerColumn2, index) in footerSecondaryMenuItem.footerColumn2">
                  <a v-if="footerColumn2.menuLink" :href="formattedMenuLink(footerColumn2.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn2.menuLabel }}</a>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer__right-column">
          <div class="footer-right-column__inner-container">
            <div class="footer__download-section">
              <h6 class="mb-3 ">{{ footerSecondaryMenuItem.appTitle ? footerSecondaryMenuItem.appTitle : "" }}</h6>
              <div v-if="footerSecondaryMenuItem.appIcons" class="flex mb-2">
                <template v-for="(appIcon, index) in footerSecondaryMenuItem.appIcons">
                  <a :href="formattedMenuLink(appIcon.iconLink)" target="_blank" class="footer__app-store-icon__container" data-ga-group="footer" data-ga-element="button" :data-ga-index="index+1" :link_text="appIcon.iconImage.altText">
                    <img :src="appIcon.iconImage.file.url" :alt="appIcon.iconImage.altText" class="footer__app-store-icon">
                    <span class="sr-only">{{ appIcon.iconImage.altText }}</span>
                  </a>
                </template>
              </div>
            </div>
            <div class="footer-right-link__section">
              <ul v-if="footerSecondaryMenuItem.footerColumn3" class="footer-right-link__container">
                <template v-for="(footerColumn3, index) in footerSecondaryMenuItem.footerColumn3">
                  <a v-if="footerColumn3.menuLink" :href="formattedMenuLink(footerColumn3.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn3.menuLabel }}</a>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="link-container">
          <div>
            <div class="footer-center-link__section default-container">
              <ul v-if="footerSecondaryMenuItem.footerColumn1" class="footer-center-link__container">
                <template v-for="(footerColumn1, index) in footerSecondaryMenuItem.footerColumn1">
                  <a v-if="footerColumn1.menuLink" :href="formattedMenuLink(footerColumn1.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn1.menuLabel }}</a>
                </template>
              </ul>
              <ul v-if="footerSecondaryMenuItem.footerColumn2" class="footer-center-link__container">
                <template v-for="(footerColumn2, index) in footerSecondaryMenuItem.footerColumn2">
                  <a v-if="footerColumn2.menuLink" :href="formattedMenuLink(footerColumn2.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn2.menuLabel }}</a>
                </template>
              </ul>
            </div>
            <div class="footer-right-link__section">
              <ul v-if="footerSecondaryMenuItem.footerColumn3" class="footer-right-link__container">
                <template v-for="(footerColumn3, index) in footerSecondaryMenuItem.footerColumn3">
                  <a v-if="footerColumn3.menuLink" :href="formattedMenuLink(footerColumn3.menuLink)" class="footer-link__item link" data-ga-group="footer" data-ga-element="item">{{ footerColumn3.menuLabel }}</a>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__copy-right-container">
      <div class="footer__copy-right-content default-container">
        <span class="mb-[12px] lg:mb-0" v-html="copyrightMessage"></span>

        <ul v-if="footerSecondaryMenuItem.footerColumn4" class="flex justify-between">
          <template v-for="(footerColumn4, index) in footerSecondaryMenuItem.footerColumn4">
            <!-- <template v-if="index > 0"> | </template> -->
            <li v-if="footerColumn4.menuLink" class="mx-2"><a :href="formattedMenuLink(footerColumn4.menuLink)" class="hover:underline" data-ga-group="footer" data-ga-element="item">{{ footerColumn4.menuLabel }}</a></li>
          </template>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import mainSite from "@/util/mainSite"
import HeaderLogo from "@/components/layout/header/icons/HeaderLogo"

export default {
  name: "secondary-footer",
  components: {
    HeaderLogo,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 1230,
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mixins: [mainSite],
  methods: {
    getSocialLink(item) {
      let link = _.get(this.site, item, "/" + this.$i18n.locale);

      if (link == null) {
        link = "/" + this.$i18n.locale;
      }

      if (!(link.includes('http'))) {
        link = process.env.VUE_APP_WK_FRONT_END_URL + link;
      }
      return link;
    },
    testgetter() {
      console.log()
    },
    formattedMenuLink(menuLink) {
      if (menuLink && menuLink.uri) {
        if (menuLink.uri.startsWith('http')) {
          return menuLink.uri
        } else {
          return process.env.VUE_APP_WK_FRONT_END_URL + menuLink.uri
        }
      } else {
        return ''
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 1230;
    },
  },
  computed: {
    copyrightMessage() {
      return this.$t("footer.copyright") + "<br/>©" + new Date().getFullYear() + this.$t("footer.copyright_2");
    },
    newsletter() {
      return process.env.VUE_APP_WK_FRONT_END_URL + "/" + this.$i18n.locale + "/the-authority/subscribe-to-e-newsletter";
    },
    headerLogoStyle() {
      return {
        width: `${this.isMobile ? this.mobileLogoWidth : this.desktopLogoWidth}px`,
        height: `${this.isMobile ? this.mobileLogoHeight : this.desktopLogoHeight}px`,
      };
    },
    ...mapState(['site', 'footerSecondaryMenuItem', 'socialMediaIcons', "blackSiteLogo", "whiteSiteLogo", "textLogo", "logoLink", "desktopLogoHeight", "desktopLogoWidth", "mobileLogoHeight", "mobileLogoWidth"]),
    ...mapGetters([]),
    isDataLoaded() {
      return Object.keys(this.footerSecondaryMenuItem).length > 0;
    },
  },
};
</script>
